var map = {
	"./B2B.png": 150,
	"./B2C.png": 151,
	"./B2G.png": 152,
	"./C2C.png": 153,
	"./G2B.png": 154,
	"./G2G.png": 155,
	"./M2B.png": 156,
	"./M2C.png": 157,
	"./M2G.png": 158
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 149;